<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :autoUpdate="autoUpdate" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import message from "../../utils/message";
    import request from "@/utils/axios.js";
    export default {
        name: "PayOrder",
        components: {CommonTable},
        data(){
            return{
                autoUpdate: true,
                searchs:[
                    {
                        name: 'orderNo',
                        placeholder: '订单号',
                        type: 'input'
                    },
                    {
                        name: 'outTradeNo',
                        placeholder: '外部订单号',
                        type: 'input'
                    },
                    {
                        name: 'siteId',
                        placeholder: '网站',
                        type: 'select',
                        selectUrl: '/siteInfo/getAll',
                        selectValue: []
                    },
                    {
                        name: 'status',
                        placeholder: '订单状态',
                        type: 'select',
                        selectValue:[
                            {
                                key: "0",
                                value: "处理中"
                            },
                            {
                                key: "1",
                                value: "成功"
                            },
                            {
                                key: "2",
                                value: "逾期订单"
                            },{
                                key: 3,
                                value: '订单取消'
                            }
                        ]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'payOrder:add',
                    update: 'payOrder:update',
                    delete: 'payOrder:delete',
                    deleteBatch: 'payOrder:deleteBatch'
                },
                url: {
                    get: '/payOrder/listByCondition',
                    add: '/payOrder/add',
                    update: '/payOrder/update',
                    delete: '/payOrder/delete/',
                    delete_batch: '/payOrder/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: false,
                    detail: true,
                    width: '75',
                },{
                    field: 'orderNo',
                    label: '订单号',
                    show: false,
                    detail: true,
                    width: '',
                },{
                    field: 'outTradeNo',
                    label: '外部订单号',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'acctNo',
                    label: '银行卡号',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'money',
                    label: '订单金额',
                    show: {
                        type: 'money'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'siteId',
                    label: '网站名称',
                    selectUrl: '/siteInfo/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'business',
                    label: '商户账号',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 0,
                            value: '处理中',
                            type: ''
                        },{
                            key: 1,
                            value: '成功',
                            type: 'success'
                        },{
                            key: 2,
                            value: '逾期订单',
                            type: 'warning'
                        },{
                            key: 3,
                            value: '订单取消',
                            type: 'danger'
                        }]
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'callback',
                    label: '回调地址',
                    detail: true,
                    width: '',
                },{
                    field: 'failCause',
                    label: '失败原因',
                    detail: true,
                    width: '',
                },{
                    field: 'updateNick',
                    label: '修改人',
                    detail: true,
                    width: '',
                },{
                    field: 'completeTime',
                    label: '完成时间',
                    show: true,
                    detail: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加订单',
                    updateTitle: '修改订单',
                    labelWidth: '105px',
                    model: [{
                        field: 'outTradeNo',
                        label: '外部订单号：',
                        type: 'input',
                        placeholder: '外部订单号',
                        rules:[{required: true, message: '请输入外部订单号', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'orderInfo',
                        label: '订单信息：',
                        type: 'input',
                        placeholder: '订单信息',
                        rules:[{required: true, message: '请输入订单信息', trigger: 'blur'}],
                        add: true,
                        update: true,
                    },{
                        field: 'money',
                        label: '订单金额：',
                        type: 'input',
                        placeholder: '订单金额',
                        rules:[{required: true, message: '请输入订单金额', trigger: 'blur'}],
                        add: true,
                        update: true,
                    }/*,{
                        field: 'taskTypeId',
                        label: '任务类型：',
                        type: 'select',
                        placeholder: '请选择',
                        rules:[{required: true, message: '请选择任务类型', trigger: 'blur'}],
                        selectUrl: '/taskType/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                    }*/,{
                        field: 'callback',
                        label: '回调地址：',
                        type: 'input',
                        placeholder: '回调地址',
                        rules:[],
                        add: true,
                        update: true,
                    }],
                },
                operate: [{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '置为成功',
                    handle: (row) => {
                        if (row.status != 0){
                            message.warning("订单的状态不可置为成功");
                            return;
                        }
                        request.post({
                            url: '/payOrder/status',
                            data: {id: row.id,status:1},
                            confirm: '确定置为成功？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.$refs.table.getData();
                                }else {
                                    message.error("操作失败");
                                }
                            }
                        });
                    }
                }],
            }
        }
    }
</script>

<style scoped>

</style>
